class SingleModels {
    constructor() {
        this.singleModel = document.querySelector(".single-models");
        if (!this.singleModel) {
            return;
        }

        this.buildGallery();
        this.buildSwiper();
        this.buildDocuments();
    }

    buildSwiper() {
        this.prevArrow = this.singleModel.querySelector('.prev-btn');
        this.nextArrow = this.singleModel.querySelector('.next-btn');
        const singleSwiper = new Swiper(".single-swiper", {
            slidesPerView: 'auto',
            spaceBetween: 30,

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },

                990: {
                    slidesPerView: 2,
                    spaceBetween: 80,
                },

                2000: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                }
            },

            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });
    }

    buildDocuments() {
        lightGallery(document.querySelector('.documents'), {
            speed: 500,
            selector: "a",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001'
        });
    }

    buildGallery() {
        lightGallery(document.querySelector('.swiper-wrapper'), {
            speed: 500,
            selector: "a",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001',
            getCaptionFromTitleOrAlt: true,
        });
    }
}